"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zustand = require("zustand");
var _pagination = require("../constants/pagination");
// Any time that usePrevNextPagination is NOT synced to location,
// store a keyed currentPage here instead
const useLocalPageStore = (0, _zustand.create)(set => ({
  pageStore: {},
  setPage: (id, page) => set(state => {
    // Any non-id keyed pages will go into a single storage slot
    const key = id ?? _pagination.DEFAULT_PAGE_KEY;
    return {
      ...state,
      pageStore: {
        ...state.pageStore,
        [key]: page
      }
    };
  })
}));
var _default = exports.default = useLocalPageStore;